import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { UserService } from '../../core/user.service';
import { User } from '../shared/models';
import { UserHeaderComponent } from '../user-header/user-header.component';

@Component({
  selector: 'app-user-list',
  imports: [RouterModule, MatButtonModule, MatIconModule, UserHeaderComponent],
  templateUrl: './user-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-list.component.scss',
})
export class UserListComponent implements OnInit {
  private service: UserService = inject(UserService);

  users = signal<User[]>([]);

  ngOnInit() {
    this.service.getUsers().subscribe((users) => {
      this.users.set(users);
    });
  }
}
